import React from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/Button';
import { Link } from 'react-router-dom';
const CATEGORIES = [{
  name: 'Accessories',
  link: '/23m8/accessories.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FCategory%20Images%2FAccessories2.JPG'
}, {
  name: 'Apparel',
  link: '/23m8/apparel.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FCategory%20Images%2Fapparel.JPG'
}, {
  name: 'Bathrooms',
  link: '/23m8/bathrooms.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FNew_Temp%2FBathrooms%2FBathroom5.jpg'
}, {
  name: 'Bedrooms',
  link: '/23m8/bedrooms.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FNew_Temp%2FBedrooms%2FBedrooms1.JPG'
}, {
  name: 'Before & After',
  link: '/23m8/before-after.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FNew_Temp%2FBefore%20%26%20After%2F140508121027.jpg'
}, {
  name: 'Commercial',
  link: '/23m8/commercial.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FP1013937.jpg'
}, {
  name: 'Dining Rooms',
  link: '/23m8/dining-rooms.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FP1014171.jpg'
}, {
  name: 'Furniture',
  link: '/23m8/furniture.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FNew_Temp%2FBedrooms%2FIMG_9817.JPG'
}, {
  name: 'Kitchens',
  link: '/23m8/kitchens.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FP1014168.jpg'
}, {
  name: 'Lighting',
  link: '/23m8/lighting.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2Flighting%20and%20bathroom.jpg'
}, {
  name: 'Living Rooms',
  link: '/23m8/living-rooms.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FP1014111.jpg'
}, {
  name: 'Lower Levels',
  link: '/23m8/lower-levels.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2Flower%20level.jpg'
}, {
  name: 'Seminars and Events',
  link: '/23m8/seminars-and-events.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FIMG_3233.jpg'
}, {
  name: 'Staging',
  link: '/23m8/staging.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FBlog%20Images%2Fclutter%20free.jpg'
}, {
  name: 'Window Treatments',
  link: '/23m8/window-treatments.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FP1013895.jpg'
}];
export function Portfolio() {
  return <Layout data-id="element-446">
      {/* Hero Section */}
      <section className="relative py-32 px-4 border-b border-taupe-200 overflow-hidden" data-id="element-447">
        {/* Background Image */}
        <div className="absolute inset-0" data-id="element-448">
          <img src="https://cdn.magicpatterns.com/uploads/nZ5xv9atcwGu9yhbhAfEJp/Portfolio_bg.jpg" alt="Down Home Interiors Portfolio" className="w-full h-full object-cover object-center" data-id="element-449" />
          <div className="absolute inset-0 bg-white/80" data-id="element-450" />
        </div>

        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-451">
          <span className="text-sage-600 uppercase tracking-[0.2em] text-xs font-semibold mb-6 block" data-id="element-452">
            Our Work
          </span>
          <h1 className="text-4xl md:text-6xl font-serif text-charcoal-900 mb-6 leading-tight" data-id="element-453">
            Portfolio of
            <br data-id="element-454" />
            <span className="italic" data-id="element-455">Completed Projects</span>
          </h1>
          <p className="text-xl text-charcoal-900/70 leading-relaxed max-w-2xl mx-auto" data-id="element-456">
            Explore a selection of residential and commercial spaces we've
            designed throughout Michigan.
          </p>
        </div>
      </section>

      {/* Intro Section */}
      <section className="py-20 px-4 bg-white border-b border-taupe-200" data-id="element-457">
        <div className="max-w-4xl mx-auto text-center" data-id="element-458">
          <h2 className="text-2xl md:text-3xl font-serif text-charcoal-900 mb-6" data-id="element-459">
            Real Projects, Real Results
          </h2>
          <p className="text-lg text-charcoal-900/70 leading-relaxed mb-6" data-id="element-460">
            This portfolio represents over two decades of design work throughout
            Michigan. From complete home renovations to carefully staged
            properties, from custom window treatments to curated retail
            collections—each image reflects our commitment to quality, attention
            to detail, and timeless aesthetic.
          </p>
          <p className="text-lg text-charcoal-900/70 leading-relaxed" data-id="element-461">
            Browse by category to find inspiration for your own project, or
            contact us to discuss how we can bring your vision to life.
          </p>
        </div>
      </section>

      {/* Category Grid */}
      <section className="py-24 px-4 bg-cream-100" data-id="element-462">
        <div className="max-w-7xl mx-auto" data-id="element-463">
          <div className="text-center mb-16" data-id="element-464">
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-4" data-id="element-465">
              Browse by Category
            </h2>
            <p className="text-lg text-charcoal-900/60" data-id="element-466">
              Select a category to view our work in that area
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-id="element-467">
            {CATEGORIES.map(category => <a key={category.name} href={category.link} className="group relative aspect-[3/4] bg-white border border-taupe-200 overflow-hidden hover:shadow-soft transition-all duration-300" data-id="element-468">
                {/* Category Image */}
                <img src={category.image} alt={category.name} className="absolute inset-0 w-full h-full object-cover" data-id="element-469" />

                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-charcoal-900/90 via-charcoal-900/30 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300" data-id="element-470" />

                {/* Category Name */}
                <div className="absolute inset-0 flex items-end p-6" data-id="element-471">
                  <div className="transform translate-y-1 group-hover:translate-y-0 transition-transform duration-300" data-id="element-472">
                    <h3 className="text-white font-serif text-lg md:text-xl leading-tight group-hover:text-sage-200 transition-colors" data-id="element-473">
                      {category.name}
                    </h3>
                  </div>
                </div>
              </a>)}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 px-4 bg-white" data-id="element-474">
        <div className="max-w-4xl mx-auto text-center" data-id="element-475">
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-6" data-id="element-476">
            Ready to Start Your Project?
          </h2>
          <p className="text-xl text-charcoal-900/70 mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-477">
            Let's discuss how we can transform your space with the same care and
            attention you see in our portfolio.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-478">
            <Link to="/contact" data-id="element-479">
              <Button size="lg" className="min-w-[200px]" data-id="element-480">
                Schedule Consultation
              </Button>
            </Link>
            <Link to="/store-info" data-id="element-481">
              <Button variant="outline" size="lg" className="min-w-[200px]" data-id="element-482">
                Visit Our Showroom
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </Layout>;
}